import { createMemoryHistory, createBrowserHistory } from 'history';
import { getCookie } from '@client/shared/utils/cookieUtils/cookieUtils';

let history;

const SUPPORTED_LANGUAGES = ['sv', 'no', 'dk', 'en'];

function detectLanguage() {
  if (typeof window !== 'undefined') {
    const pathLng = window.location.pathname.slice(1, 3);
    if (SUPPORTED_LANGUAGES.includes(pathLng)) return pathLng;
  }
  return getCookie('language') ?? 'sv';
}

const lng = detectLanguage();
const baseUrl = { basename: `/${lng}` };
if (process.env.SERVER === true) {
  // Server should use createMemoryHistory
  history = createMemoryHistory();
} else {
  // client should use createBrowserHistory
  history = createBrowserHistory(baseUrl);
}

export default history;
